import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPorkFeedInformation, getPorkFeedInformationAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PORK_FEED_INFORMATION } from "consts";

export const useGetFootprintingPorkFeedInformationByPrimaryDataId = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_FEED_INFORMATION, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getPorkFeedInformationAdmin(primaryDataId) : getPorkFeedInformation(primaryDataId)),
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
